import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Stats = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-ink text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {t.proof.items.map((item) => (
            <div key={item.label} className="border-l border-white/15 pl-4">
              <p className="font-display font-extrabold text-2xl sm:text-3xl text-mint-soft">
                {item.value}
              </p>
              <p className="mt-1 text-sm text-white/65">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
